module.exports = __webpack_public_path__ + "img/con_rf.c50efd8d.png";